import React from 'react';
import { Helmet } from 'react-helmet';
var SiteNavigationElementSchema = function SiteNavigationElementSchema(_ref) {
  var navigationElementId = _ref.navigationElementId,
    siteUrl = _ref.siteUrl,
    pages = _ref.pages;
  var navigationData = {
    '@context': 'http://schema.org',
    '@graph': pages.map(function (_ref2) {
      var slug = _ref2.slug,
        title = _ref2.title;
      return {
        '@context': 'https://schema.org',
        '@type': 'SiteNavigationElement',
        '@id': navigationElementId,
        name: title,
        url: "".concat(siteUrl).concat(slug)
      };
    })
  };
  return /*#__PURE__*/React.createElement(Helmet, {
    defer: false
  }, /*#__PURE__*/React.createElement("script", {
    type: "application/ld+json"
  }, JSON.stringify(navigationData)));
};
export default SiteNavigationElementSchema;
SiteNavigationElementSchema.defaultProps = {
  navigationElementId: '#nav'
};